export const getJwt = (key = 'jwt'): string | null => {
    if (typeof window === 'undefined') return null
    const token = localStorage.getItem(key)
    return token || null
}

export const storeJwt = (jwt: string, key = 'jwt'): void => {
    if (typeof window === 'undefined') return
    localStorage.setItem(key, jwt)
}

export const removeJwt = (key = 'jwt'): void => {
    if (typeof window === 'undefined') return
    localStorage.removeItem(key)
}

export const isAuthed = () => getJwt() !== null
